import { render, staticRenderFns } from "./appTg.vue?vue&type=template&id=1d3beb2e&scoped=true"
import script from "./appTg.vue?vue&type=script&lang=js"
export * from "./appTg.vue?vue&type=script&lang=js"
import style0 from "./appTg.vue?vue&type=style&index=0&id=1d3beb2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3beb2e",
  null
  
)

export default component.exports